import React from 'react';
import { RichTextStyles as S } from './RichText.styles';
const RichText = ({ alignment = 'left', content, id }) => {
    return (React.createElement(S.Container, { id: id, innerWidth: "narrow", flush: "top" },
        React.createElement(S.Inner, { "data-alignment": alignment },
            React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }))));
};
export default RichText;
